import React, { Component } from 'react'
import Collector from '../../containers/Collector/Collector'
import Footer from '../../containers/Footer/Footer'
import Hat from '../../containers/Hat/Hat'
import MainPage from '../../containers/MainPage/MainPage'
import classes from './Layout.css'
import { Route } from 'react-router-dom'
import Feadback from '../../containers/Feadback Form/feadbackForm'
import WorkInfo from '../../containers/Collector/work-principle/workInfo'
import Construction from '../../containers/Collector/Collector Constaruction/Constaruction'
class Layout extends Component {
    feabackData = (InputData) => {
        return InputData
    }
    render() {
        return (
            <div className={classes.Layout}>
                <Hat />
                <Route path='/collector/construction' exact component={Construction} />
                <Route path='/' exact component={MainPage} />
                <Route path='/feadback' exact component={Feadback} />
                <Route path='/collector/work-principle' exact component={WorkInfo} />


                <Footer />
            </div>
        )
    }
}
export default Layout


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js